import { useEffect } from 'react';
var useFavicon = function (href) {
    useEffect(function () {
        var link = document.querySelector("link[rel*='icon']") || document.createElement('link');
        link.type = 'image/x-icon';
        link.rel = 'shortcut icon';
        link.href = href;
        document.getElementsByTagName('head')[0].appendChild(link);
    }, [href]);
};
export default useFavicon;



//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/react-use/esm/useFavicon.js
// module id = pYyS
// module chunks = 0